import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { merge, Observable } from 'rxjs';
import { SimplifiedConnectedBreakpointService } from './simplified-connected-breakpoint.service';
import { map } from 'rxjs/operators';

const HEIGHT_SMALL_BREAKPOINT = '(max-height: 500px)';
const TAILWIND_BREAKPOINTS = {
  sm: '(min-width: 640px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 1024px)',
  xl: '(min-width: 1280px)',
  xxl: '(min-width: 1536px)',
};

@Injectable({
  providedIn: 'root',
})
export class BreakpointService implements SimplifiedConnectedBreakpointService {
  sm$: Observable<boolean>;
  md$: Observable<boolean>;
  lg$: Observable<boolean>;
  xl$: Observable<boolean>;
  xxl$: Observable<boolean>;
  change$: Observable<boolean>;

  constructor(public breakpointObserver: BreakpointObserver) {
    this.sm$ = this.observe(TAILWIND_BREAKPOINTS.sm);
    this.md$ = this.observe(TAILWIND_BREAKPOINTS.md);
    this.lg$ = this.observe(TAILWIND_BREAKPOINTS.lg);
    this.xl$ = this.observe(TAILWIND_BREAKPOINTS.xl);
    this.xxl$ = this.observe(TAILWIND_BREAKPOINTS.xxl);
    this.change$ = merge(this.md$, this.xl$).pipe(map(() => true));
  }

  get sm() {
    return this.breakpointObserver.isMatched(TAILWIND_BREAKPOINTS.sm);
  }

  get md() {
    return this.breakpointObserver.isMatched(TAILWIND_BREAKPOINTS.md);
  }

  // noinspection JSUnusedGlobalSymbols
  get lg() {
    return this.breakpointObserver.isMatched(TAILWIND_BREAKPOINTS.lg);
  }

  get xl() {
    return this.breakpointObserver.isMatched(TAILWIND_BREAKPOINTS.xl);
  }

  // noinspection JSUnusedGlobalSymbols
  get xxl() {
    return this.breakpointObserver.isMatched(TAILWIND_BREAKPOINTS.xxl);
  }

  get isSmallHeight() {
    return this.breakpointObserver.isMatched(HEIGHT_SMALL_BREAKPOINT);
  }

  private observe(size: string) {
    return this.breakpointObserver.observe(size).pipe(map((x) => x.matches));
  }
}
